import React from "react";
import { useNextInput } from "../useNextInput";
import ActionButton from "../../base/premeeting/components/web/ActionButton";
//@ts-ignore
import InputField from "../../base/premeeting/components/web/InputField";
import { useTranslation } from "react-i18next";
const LoginForm = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const { registerInput } = useNextInput();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { width: "100%", height: 45 } },
            React.createElement(InputField, { ref: registerInput, autoFocus: true, onChange: (value) => {
                    props.setUsername(value);
                    props.setError(Object.assign(Object.assign({}, props.error), { username: "" }));
                }, 
                //value={''}
                placeHolder: t("login.username") }),
            React.createElement("p", { style: {
                    color: "red",
                    display: "flex",
                } }, (_a = props === null || props === void 0 ? void 0 : props.error) === null || _a === void 0 ? void 0 : _a.username)),
        React.createElement("div", { style: { marginTop: 30, width: "100%" } },
            React.createElement(InputField
            // className={showError ? "error" : ""}
            // hasError={showError}
            , { 
                // className={showError ? "error" : ""}
                // hasError={showError}
                ref: registerInput, type: "password", onChange: (value) => {
                    props.setPassword(value);
                    props.setError(Object.assign(Object.assign({}, props.error), { password: "" }));
                }, 
                //value={''}
                placeHolder: t("login.password") }),
            React.createElement("p", { style: {
                    color: "red",
                    display: "flex",
                } }, (_b = props === null || props === void 0 ? void 0 : props.error) === null || _b === void 0 ? void 0 : _b.password)),
        React.createElement("div", { style: { marginTop: 30 } },
            React.createElement(ActionButton, { ref: registerInput, className: "button-login", onClick: props.onSubmit, testId: "prejoin.joinMeeting", type: "primary" }, t("login.signIn")),
            React.createElement("p", { style: {
                    color: "red",
                    marginTop: 10,
                    display: "flex",
                } }, props.renderErrorMsg()))));
};
export default LoginForm;
